/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/feature_flag_limits" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdFeatureFlagLimits } from "./constants";
import type { EngagementAppGroupIdFeatureFlagLimitsResult } from "./types";

export const getEngagementAppGroupIdFeatureFlagLimits = reactQueryFetcherAdapter(
  engagementAppGroupIdFeatureFlagLimits,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementAppGroupIdFeatureFlagLimitsResult> => {
    return fetch(`/engagement/${appGroupId}/feature_flag_limits`, "GET", {}, { signal });
  }
);
